import { Route, Routes } from 'react-router-dom';
import PartnerListPage from './list';

export default function PartnerRouting() {
  return (
    <Routes>
      <Route index element={<PartnerListPage />} />
    </Routes>
  );
}
